
import { HasConfirmationOfDeleting } from "../abstracts/mixins/HasConfirmationOfDeleting";
import { CRUDEntity } from "../abstracts/CRUDEntity";
import { FormActions } from "../abstracts/mixins/FormActions";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { RelatedEntities } from "../abstracts/mixins/RelatedEntities";
import { Validator, ValidationError } from "../../snippets/Validator";
import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import masks from "../../masks.js";
import Errors from '../../errors.js';

export class Customer extends CRUDEntity {

    #validation_fields = [
        'email',
        'phone',
        'first_name',
        'last_name',
        'address',
        'city',
        'state',
        'zip_code',
    ]

    constructor(id=null) {

        Object.assign(Customer.prototype, FormActions);
        Object.assign(Customer.prototype, EntityModalForm);
        Object.assign(Customer.prototype, RelatedEntities);
        Object.assign(Customer.prototype, HasConfirmationOfDeleting);
        Object.assign(Customer.prototype, HasAttachments);


        super();
        this.setAttachmentCallbackDelete()
        this.entityClass = 'customer';
        this.urlRoot = '/customers';
        this.sectionRootUrl = '/customers';
        this.id = id;

        Customer.prototype.collectDataInForm = function(formId) {
            let data = {};
            let inputs = $(`#${formId} input, #${formId} textarea, #${formId} select`);

            for (let input of inputs) {
                input = $(input);
                if (input.attr('type') == 'checkbox') {
                    data[input.attr('name')] = input.is(':checked');
                } else {
                    data[input.attr('name')] = input.val();
                }
            }
            return data;
        }

        Customer.prototype.delegatedListnersForButtons = function(type, entityClass) {
            masks.init();
            const validateCb = () => {
                if(this.validationForm(type))
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',false)
                else
                    $(`#${type}-${entityClass} button#${type}`).attr('disabled',true)
            }
            for(let field of this.#validation_fields){
                $(`#${type}-${entityClass} input[name=${field}]`).on('input',validateCb)
            }
            if(type == 'edit')
                validateCb()
            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if(this.validationForm(type,true)){
                    if (type === 'create') {
                        this.create(this.callbackCloseModal,(response)=>Errors.showAlerts(response.responseJSON.errors));
                    }
                    if (type == 'edit') {
                        this.update(this.callbackCloseModal,(response)=>Errors.showAlerts(response.responseJSON.errors));
                    }
                }
            });
        }
    }


    validationForm(type, isSelectErrorFields=false){
        const formId = `${type}-${this.entityClass}`;
        const data = this.collectDataInForm(formId);
        const validator = new Validator({
            // 'email': ['required'], //задача сделать почту не обязательным параетром
            'phone': ['required', {regexp: /^[0-9]{3}-[0-9]{3}-[0-9]{4}/}],
            'first_name': ['required'],
            'last_name': ['required'],
        });

        let validate_flag = true;

        this.#validation_fields.forEach(element => {
            if (validator.validate(element, data[element])) {
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').attr('style','');
            }else{
                validate_flag = false;
                if(isSelectErrorFields)
                    $('#'+formId+' [name="'+element+'"]').attr('style','border:2px solid #DB3A57 !important;');
            }
        });

        if (data['email'] && !$('#'+formId+' [name="send_email"]').hasClass('disabled')) {
            $('#'+formId+' [name="send_email"]').removeAttr('disabled');
        }

        return validate_flag;
    }

    static validateNewCustomer(formSelector='.create-new-customer') {
        let email = $(`${formSelector} [name='email']`);
        let phone = $(`${formSelector} [name='phone']`);
        let first_name = $(`${formSelector} [name='first_name']`);
        let last_name = $(`${formSelector} [name='last_name']`);
        let errors = 0;

        if (/^\S+@\S+\.\S+$/.test(email.val())) {
            email.attr('style', '');
        } else {
            email.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (/^\d{3}-\d{3}-\d{4}$/.test(phone.val())) {
            phone.attr('style', '');
        } else {
            phone.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (first_name.val().length > 0) {
            first_name.attr('style', '');
        } else {
            first_name.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (last_name.val().length > 0) {
            last_name.attr('style', '');
        } else {
            last_name.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        return (errors > 0) ? false : true;
    }
}
